module.exports = __webpack_public_path__ + "images/Selected-file.3a7a261dfdab19c20f7b21ba7910c022.svg";